import {
  BLOCK_PREFIX,
  ENTITY_DATA_SOURCE_PREFIX,
  ENTITY_DATA_SOURCE_SEPARATOR,
  ENTITY_PREFIX,
  FUNCTION_PREFIX,
  RUN_TIME_BLOCK_KEY,
  VARIABLE_PREFIX,
} from '../const';
import { RESERVED_COMPUTE_CONTEXT_KEYS } from '../hooks/computeContext/const';

const ETL_LOGS_PREFIX = '__ETL_LOGS';
const API_COLLECTION_PREFIX = '__API_COLLECTION';
const UA_STANDARD_INTERFACES_ENTITY_PREFIX = '__ua';
const CAMPAIGN_REPORTING_PREFIX = '__CAMPAIGN_REPORTING';

const allPrefixes = [
  VARIABLE_PREFIX,
  FUNCTION_PREFIX,
  RUN_TIME_BLOCK_KEY,
  BLOCK_PREFIX,
  ENTITY_PREFIX,
  ETL_LOGS_PREFIX,
  UA_STANDARD_INTERFACES_ENTITY_PREFIX,
  API_COLLECTION_PREFIX,
  CAMPAIGN_REPORTING_PREFIX,
].map((prefix) => `${prefix}_`);

// keep this separate because it doesn't end with _ but uses -
const REPORTING_AI_PREFIX = 'reporting-api-';

const RESERVED_LOGIN_DATASOURCE_IDS = [
  'usernameLoginRequest',
  'loginRequest',
  'fetchIDPs',
  'emailAndPassLoginRequest',

  'ua_governance_ds_send_forget_password_email',

  'resendCode',
  'verifyCode',

  'emailAndPasswordPublicLogin',

  'ua_governance_data_source_valid_session_id',
  'ua_governance_data_source_reset_password',

  'updatePasswordDatasource',
];

const allEntities = [
  ...RESERVED_LOGIN_DATASOURCE_IDS,
  REPORTING_AI_PREFIX,
  ...allPrefixes,
  // adding ENTITY_DATA_SOURCE_PREFIX separate because it doesn't end with _ but rather $
  `${ENTITY_DATA_SOURCE_PREFIX}${ENTITY_DATA_SOURCE_SEPARATOR}`,
  ...RESERVED_COMPUTE_CONTEXT_KEYS,
];

export const isNoCodeEntityId = (id: string) => {
  return allEntities.some((prefix) => id.startsWith(prefix));
};
